import { useEffect, useState } from "react";

import { useParams } from "react-router-dom";

import { CircularProgress } from "@material-ui/core";

import { getShipments } from "api/shipment";

import PageTitle from "components/PageTitle";

import { initialAPIListValue } from "utils/constants";

import LTLShipmentPreview from "./LTLShipmentPreview";

// Read-only LTL shipment detail page for OBT/seller users. It is identical to
// the internal LTL detail page, only without any actions.
export default function SellerLTLShipmentDetail() {
  const { shipment_id } = useParams();
  const [shipment, setShipment] = useState(initialAPIListValue);

  useEffect(() => {
    getShipments({
      id: shipment_id,
      responseSetter: (data) => setShipment({ isFetching: false, ...data }),
    });
  }, [shipment_id]);

  return shipment.isFetching ? (
    <CircularProgress />
  ) : (
    <>
      <PageTitle
        title={shipment.shipment_number}
        backLink="/app/seller/ltl-shipments"
      />
      <LTLShipmentPreview shipment={shipment} />
    </>
  );
}
